"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgSearchHeavy(props) {
  return React.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    stroke: props.stroke,
    fill: props.fill
  }, props), React.createElement("path", {
    d: "M11.087 5a6.087 6.087 0 014.952 9.627l.016.014 2.652 2.652a1 1 0 01-1.414 1.414l-2.652-2.652-.014-.016A6.087 6.087 0 1111.087 5zm0 2a4.087 4.087 0 100 8.174 4.087 4.087 0 000-8.174z",
    fill: "inherit",
    fillRule: "evenodd"
  }));
}

var _default = SvgSearchHeavy;
exports.default = _default;